import { Heart, Globe, Sparkles, Users } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-stone-50 pt-24 pb-16" data-testid="about-page">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold tracking-[0.32em] uppercase text-[#c4956a]">
            About · New Coupling
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-stone-900 mt-3 mb-2">
            우리가 만들고 있는 이야기
          </h1>
          <p className="text-stone-500">
            글로벌 한인 중년을 위한 프리미엄 감성 커뮤니티
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-stone-200 p-8 space-y-8 text-stone-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-stone-900 mb-3 flex items-center gap-2">
              <Heart className="w-5 h-5 text-burgundy-500" />
              우리의 미션
            </h2>
            <p className="text-[15px]">
              New Coupling은 전 세계에 흩어져 살아가는 한인 중년들이
              <strong> 외롭지 않게, 그리고 품격 있게 </strong>
              새로운 인연과 일상의 공감을 나눌 수 있도록 만들어졌습니다.
              사랑은 나이가 들수록 더 신중해지고, 더 따뜻해집니다. 우리는 그 시간을 함께 합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-stone-900 mb-3 flex items-center gap-2">
              <Globe className="w-5 h-5 text-burgundy-500" />
              누구를 위한 서비스인가요?
            </h2>
            <ul className="space-y-2 text-[15px]">
              <li>· 한국·캐나다·미국·유럽 등 전 세계에 거주하는 만 40~70세 한인 싱글</li>
              <li>· 미혼·이혼·사별·재혼 희망자 모두 환영합니다</li>
              <li>· 진중한 만남과 따뜻한 공감 커뮤니티를 함께 원하시는 분</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-stone-900 mb-3 flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-burgundy-500" />
              우리가 제공하는 것
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-[14.5px]">
              <div className="p-4 rounded-xl bg-stone-50 border border-stone-100">
                <p className="font-semibold text-stone-900 mb-1">감성 SNS 커뮤니티</p>
                <p className="text-stone-600">하루의 기록, 솔직한 고민, 위로의 댓글이 머무는 공간</p>
              </div>
              <div className="p-4 rounded-xl bg-stone-50 border border-stone-100">
                <p className="font-semibold text-stone-900 mb-1">AI 매칭 & 줌미팅</p>
                <p className="text-stone-600">결이 맞는 사람을 만나는 격주 줌데이트와 1:1 매칭</p>
              </div>
              <div className="p-4 rounded-xl bg-stone-50 border border-stone-100">
                <p className="font-semibold text-stone-900 mb-1">연애 코칭·컨설팅</p>
                <p className="text-stone-600">자존감·소통·연애·결혼학과 4단계 커리큘럼</p>
              </div>
              <div className="p-4 rounded-xl bg-stone-50 border border-stone-100">
                <p className="font-semibold text-stone-900 mb-1">오프라인 이벤트</p>
                <p className="text-stone-600">매칭&디너, 소모임, 힐링캠프 등 안전하고 품격 있는 만남</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-stone-900 mb-3 flex items-center gap-2">
              <Users className="w-5 h-5 text-burgundy-500" />
              운영 주체
            </h2>
            <div className="text-[14.5px] space-y-1.5 text-stone-600">
              <p><span className="font-semibold text-stone-800">캐나다</span> · Liz TV Inc. (사업자 번호 1465735-7)</p>
              <p><span className="font-semibold text-stone-800">한국</span> · 리즈티비 코리아 Liz TV Korea (사업자 번호 781-01-03665)</p>
              <p className="pt-2 text-stone-500">
                문의 · <a href="mailto:contact@newcoupling.com" className="text-burgundy-500 hover:underline">contact@newcoupling.com</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
